// extracted by mini-css-extract-plugin
var _1 = "Footer-module_footer__IeSWUA";
export { _1 as "footer" }
